<template>
	<div class="d-flex align-center justify-center flex-column">
		<div class="max-width-container">
			<div class="mb-5">
				<h1 class="title font-weight-bold mt-6 mb-2 ml-3 color-titulo">Atas de Registro de Preços</h1>
				<az-search
					class="advanced-search-ata"
					:filter="filtroSimpleSearch"
					simple-search-placeholder="Busque por N° Ata, descrição ou item"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
					@advanced-search="buscarFechandoSearchBar"
					@clear="limparBusca"
				>
					<template #search-items>
						<az-search-item>
							<v-text-field
								label="Ano Início Vigência"
								v-model="filtro.anoInicioValidade.value"
								v-mask="'####'"
								maxlength="4"
								clearable
								inputmode="numeric"
							>
							</v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field
								label="Ano Fim Vigência"
								v-model="filtro.anoFimValidade.value"
								v-mask="'####'"
								maxlength="4"
								clearable
								inputmode="numeric"
							>
							</v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field
								label="Participantes"
								v-model="filtro.orgaoParticipante.value"
								clearable
							></v-text-field>
						</az-search-item>
						<az-search-item>
							<v-text-field
								label="Gerenciador"
								v-model="filtro.orgaoGerenciador.value"
								clearable
							></v-text-field>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Atas Caronas"></label-personalizado>
							<v-radio-group v-model="filtro.isAtaAdesao.value" row name="Atas Caronas" mandatory>
								<v-radio
									v-for="opcaoSimNao in getOpcaoSimNao"
									:key="opcaoSimNao.value"
									:label="opcaoSimNao.text"
									:value="opcaoSimNao.value"
								></v-radio>
							</v-radio-group>
						</az-search-item>
						<az-search-item>
							<label-personalizado nome-campo="Atas"></label-personalizado>
							<v-radio-group v-model="filtro.vigenciaAta.value" row name="Atas" mandatory>
								<v-radio
									v-for="filtroVigenciaAta in getFiltroVigenciaAta"
									:key="filtroVigenciaAta.value"
									:label="filtroVigenciaAta.text"
									:value="filtroVigenciaAta.value"
								></v-radio>
							</v-radio-group>
						</az-search-item>
					</template>
				</az-search>
			</div>
			<az-container class="listagem mx-0">
				<ata-listagem
					:itens="datasource"
					:total-paginas="totalPaginas"
					:total-itens="totalItens"
					:paginacao="paginacao"
					@paginar="setPaginacaoAtaListagem"
					@resetar-page="resetarPaginaItemAtaListagem()"
				></ata-listagem>
			</az-container>
		</div>
	</div>
</template>
<script>
import AtaListagem from './listagem/AtaListagem'
import { mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'
import { actionTypes, filtroVigenciaAta, opcaoSimNao } from '@/core/constants'

export default {
	name: 'pesquisa-ata-view',
	components: {
		AtaListagem,
	},
	data() {
		return {
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			paginacao: this.$store.state.ata.paginacao,
		}
	},
	computed: {
		...mapState({
			filtro: (state) => state.ata.filtro,
			filtroSimpleSearch: (state) => state.ata.filtroSimpleSearch,
		}),
		getFiltroVigenciaAta() {
			return Object.values(filtroVigenciaAta)
		},
		getOpcaoSimNao() {
			return Object.values(opcaoSimNao)
		},
	},
	async mounted() {
		this.$store.commit(mutationTypes.ATA.RESET_INFORMACOES_ATA)
		this.$refs.componenteAzSearch.hasAdvancedSearchItems = true
		await this.carregarAtas()
	},
	methods: {
		async removerFiltros(propriedade, atualizarListagem = true) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}

			if (this.filtroSimpleSearch[propriedade]) {
				this.filtroSimpleSearch[propriedade].value = this.filtroSimpleSearch[propriedade].default
			}

			if (atualizarListagem) await this.carregarAtas()
		},
		async limparBusca() {
			this.$store.commit(mutationTypes.ATA.LIMPAR_FILTRO_LISTAGEM)
			this.setarFiltrosDefaults()
			await this.carregarAtas()
		},
		async buscarFechandoSearchBar() {
			await this.buscar()
			this.$refs.componenteAzSearch.toggle()
		},
		async buscar(searchText) {
			if (searchText) {
				this.filtro.numeroDescricaoAtaCodigoDescricaoItem.value = searchText
				this.filtroSimpleSearch.numeroDescricaoAtaCodigoDescricaoItem.value = searchText
			}

			this.resetarPaginaItemAtaListagem()
			await this.carregarAtas()
		},
		setarFiltrosDefaults() {
			for (const key of Object.keys(this.filtro)) this.removerFiltros(key, false)
		},
		async carregarAtas() {
			const retorno = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_FILTRO)
			this.totalPaginas = retorno.totalPages
			this.totalItens = retorno.totalElements
			this.datasource = retorno.itens
		},
		setPaginacaoAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ATA.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarAtas()
		},
		resetarPaginaItemAtaListagem() {
			this.$store.commit(mutationTypes.ATA.RESETAR_PAGINA_LISTAGEM)
		},
	},
}
</script>

<style lang="stylus">
.color-titulo
	color: var(--v-primary-base);

.advanced-search-bar
	top 15px !important
	height calc(100% - 23px) !important

@media screen and (min-width: 750px)
	.input-search
		width 350px !important

.advanced-search-ata .simple-search .input-search
	overflow-x scroll
	scrollbar-width: none

.v-radio .v-input--selection-controls__input
	margin-right 6px !important

.v-radio .v-label
	font-size 14px

.input-search
	background-color: #fff !important
	flex-grow 1

.simple-search,
.az-search
	flex-grow 1

.max-width-container
	width 80%
</style>
